import { Card, CardBody, Col } from "reactstrap";
import { BryanOwens, GloriaAcheson, Href, PrimaryBorderState, TeresaMosteller } from "../../../../Constant";
import { BORDER_PRIMARY } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { Image, LI, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const BorderPrimaryState = () => {
  return (
    <Col xxl="4" md="6">
      <Card className="height-equal">
        <CommonCreativeCardHeader headerClass="border-l-primary border-3" title={PrimaryBorderState} span={BORDER_PRIMARY} />
        <CardBody>
          <UL>
            <LI tag="a" className="list-group-item-action active" href={Href}><Image className="rounded-circle px-2" src={dynamicImage("user/5.jpg")} alt="user" />{TeresaMosteller}</LI>
            <LI tag="a" className="list-group-item-action" href={Href}><Image className="rounded-circle px-2" src={dynamicImage("user/5.jpg")} alt="user" />{GloriaAcheson}</LI>
            <LI tag="a" className="list-group-item-action" href={Href}><Image className="rounded-circle px-2" src={dynamicImage("user/5.jpg")} alt="user" />{BryanOwens}</LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderPrimaryState;
